import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  grid-area: CardPrimary;
  background-color: ${props => props.theme.colors.card};
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid ${props => props.theme.colors.border_grey}30;
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: relative;
  overflow: hidden;

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    padding: 20px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 0;
`;

export const ContainerSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const IconBadge = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.color}14;
  color: ${props => props.color};
  margin-bottom: 4px;
`;

export const Title = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${props => props.theme.colors.grey_text};
`;

export const Value = styled.h2`
  color: ${props => props.theme.colors.text};
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  margin: 0;
  line-height: 1.2;
`;

export const Subtitle = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${props => props.theme.colors.grey_text};
`;

export const SecondaryValue = styled.span`
  color: ${props => props.theme.colors.text};
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-self: center;

  @media (max-width: 576px) {
    align-self: stretch;
    width: 100%;
  }
`;

export const ActionButton = styled.button<{ variant: 'primary' | 'danger' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 150ms ease;
  background-color: ${props => props.variant === 'primary' ? props.theme.colors.positive : props.theme.colors.negative}14;
  color: ${props => props.variant === 'primary' ? props.theme.colors.positive : props.theme.colors.negative};

  &:hover {
    background-color: ${props => props.variant === 'primary' ? props.theme.colors.positive : props.theme.colors.negative}24;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 576px) {
    flex: 1;
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: flex;
`;
